<section class="mu-home font-size-14">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="trackerDetailsForm">
            <div class="row">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">View/Update Offline Tracker Details</h3>
              </div>
              <div class="row row-cols-6">
                <div class="col-md-6 col-12">
                  <div class="sub-header">Basic Info</div>

                  <div class="row p-2">
                    <div class="col-4">Offline Tracker ID</div>
                    <div class="col">{{ offlineTrackerDetails?.displayId }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Display ID</div>
                    <div class="col">{{ offlineTrackerDetails?.companyEntityDisplayId }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Employee ID</div>
                    <div class="col">{{ offlineTrackerDetails?.employeeCode }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">First Name</div>
                    <div class="col">{{ offlineTrackerDetails?.firstName }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Middle Name</div>
                    <div class="col">{{ offlineTrackerDetails?.middleName }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Last Name</div>
                    <div class="col">{{ offlineTrackerDetails?.lastName }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Received Date</div>
                    <div class="col">{{ offlineTrackerDetails?.receivedDate | date : 'dd/MM/yyyy' }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Received Month</div>
                    <div class="col">{{ offlineTrackerDetails?.receivedDate | date : "MMM''yy" }}</div>
                  </div>

                  <div class="row p-2">
                    <label for="uanNumber" class="form-label">UAN Number<sup>*</sup></label>

                    <input
                      class="form-control"
                      type="text"
                      formControlName="uanNumber"
                      (input)="validateUAN($event)"
                      [ngClass]="{
                        'is-invalid': f['uanNumber'].errors && f['uanNumber'].touched
                      }"
                      maxlength="12" />
                    <app-validation
                      field="uanNumber"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                  <div class="row p-2">
                    <label for="memberId" class="form-label">Unique Member Id<sup>*</sup></label>

                    <input
                      type="text"
                      class="form-control"
                      aria-label="Member Id"
                      formControlName="memberId"
                      (input)="validatePFNumber($event)"
                      [ngClass]="{
                        'is-invalid': f['memberId'].errors && f['memberId'].touched
                      }"
                      maxlength="21" />
                    <app-validation
                      field="memberId"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This is a mandatory field',
                        invalid: 'Invalid Unique Member ID',
                        pattern: 'Invalid UAN format, should contain only numbers',
                        minLength: 'Unique Member ID should have a minimum of 21 characters',
                        maxLength: 'Unique Member ID should not exceed 21 characters',
                      }"></app-validation>
                  </div>
                  <div class="row p-2">
                    <label for="additionalDetails" class="form-label">Additional Details</label>
                    <textarea
                      class="form-control"
                      formControlName="additionalDetails"
                      [ngClass]="{
                        'is-invalid': f['additionalDetails'].errors && f['additionalDetails'].touched
                      }"></textarea>
                    <app-validation
                      field="additionalDetails"
                      [form]="trackerDetailsForm"
                      [error]="{
                          minLength: 'Additional Details should have a minimum of 3 characters',
                          maxLength: 'Additional Details should should not exceed 100 characters',
                        }"></app-validation>
                  </div>
                </div>

                <div class="col-md-6 col-12 basic-info-2-container">
                  <div class="row p-2">
                    <label for="mobileNumber" class="form-label">Mobile Number</label>
                    <div class="mobile-input-group">
                      <select
                        formControlName="mobileCountryCode"
                        class="form-control mobile-country-code"
                        [ngClass]="{ 'is-invalid': f?.['mobileCountryCode']?.errors && f?.['mobileCountryCode']?.touched }">
                        <option *ngFor="let countryCode of countryCodes">
                          {{ countryCode.dialCode }}
                        </option>
                      </select>

                      <input
                        type="text"
                        placeholder=""
                        value=""
                        formControlName="mobileNumber"
                        class="form-control form-control-fixed-phone mobile-number-input"
                        [ngClass]="{ 'is-invalid': f?.['mobileNumber']?.errors && (f?.['mobileNumber']?.touched) }"
                        maxlength="10" />
                    </div>
                    <app-validation
                      field="mobileNumber"
                      [form]="trackerDetailsForm"
                      [error]="{ pattern: 'Please enter a valid 10-digit mobile number' }">
                    </app-validation>
                    <app-validation
                      field="mobileCountryCode"
                      [form]="trackerDetailsForm"
                      [error]="{ pattern: 'This field is required' }">
                    </app-validation>
                  </div>
                  <div class="row p-2">
                    <label for="emailId" class="form-label">Mail ID <sup *ngIf="isEmailIdMandatory">*</sup></label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="emailId"
                      [ngClass]="{
                        'is-invalid': f['emailId'].errors && f['emailId'].touched
                      }" />
                    <app-validation
                      *ngIf="isEmailIdMandatory"
                      field="emailId"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                    <app-validation
                      field="emailId"
                      [form]="trackerDetailsForm"
                      [error]="{
                          email: 'Enter a valid email Id',
                          minLength: 'Email Id should have a minimum of 3 characters',
                          maxLength: 'Email Id should should not exceed 70 characters',
                        }"></app-validation>
                  </div>
                  <div class="row p-2">
                    <label for="employeeStatus" class="form-label">Employee Status<sup>*</sup></label>
                    <select
                      class="form-select"
                      aria-label="Employee Status"
                      formControlName="employeeStatus"
                      [ngClass]="{
                        'is-invalid': f['employeeStatus'].errors && f['employeeStatus'].touched
                      }">
                      <option [disabled]="true" selected value="">Select Employee Status</option>
                      <option *ngFor="let option of employeeStatusOptionsList" value="{{ option?.key2 }}">
                        {{ option?.key1 }}
                      </option>
                    </select>
                    <app-validation
                      field="employeeStatus"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                  <div class="row">
                    <app-multi-dropdown-add-option
                      class="multi-dropdown"
                      [options]="multiDropdownOptions?.RECEIVED_MODE?.list"
                      label="Documents Received"
                      label="Received Mode"
                      (optionSelected)="onMultiSelectChange($event, 'receivedMode')"
                      (newOptionAdded)="onNewOptionAdded($event, 'receivedMode')"
                      [selectedOptions]="multiDropdownOptions.RECEIVED_MODE.selectedOptions">
                    </app-multi-dropdown-add-option>
                    <app-validation
                      field="receivedMode"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>

                  <div class="row">
                    <app-multi-dropdown-add-option
                      class="multi-dropdown"
                      [options]="multiDropdownOptions?.RECEIVED_DOCUMENTS.list"
                      label="Documents Received"
                      (optionSelected)="onMultiSelectChange($event, 'receivedDocuments')"
                      (newOptionAdded)="onNewOptionAdded($event, 'receivedDocuments')"
                      [selectedOptions]="multiDropdownOptions.RECEIVED_DOCUMENTS.selectedOptions">
                    </app-multi-dropdown-add-option>
                    <app-validation
                      field="receivedDocuments"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                  <div class="row">
                    <app-multi-dropdown-add-option
                      class="multi-dropdown"
                      [options]="multiDropdownOptions?.NATURE_OF_ISSUE?.list"
                      label="Nature of Issue"
                      (optionSelected)="onMultiSelectChange($event, 'natureOfIssue')"
                      (newOptionAdded)="onNewOptionAdded($event, 'natureOfIssue')"
                      [selectedOptions]="multiDropdownOptions.NATURE_OF_ISSUE.selectedOptions">
                    </app-multi-dropdown-add-option>
                    <app-validation
                      field="natureOfIssue"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                </div>
              </div>
              <div class="row status-info-container">
                <div class="sub-header">Status Info</div>

                <div class="col-md-6">
                  <div>
                    <app-status-selector
                      [selectedStatus]="offlineTrackerDetails?.status"
                      [categoryName]="offlineTrackerDetails?.taskCategory"
                      [subCategoryName]="offlineTrackerDetails?.taskSubCategory"
                      [moduleName]="MODULENAME"
                      [code]="offlineTrackerDetails?.taskCode"
                      [isRequired]="true"
                      (onSelect)="onStatusSelected($event)"
                      (onStatusChange)="onStatusChange($event)"
                      [emitStatusList]="true"
                      (fetchStatusList)="onStatusListReceived($event)"></app-status-selector>
                  </div>

                  <div class="pt-2">
                    <label for="statusDate" class="form-label"
                      >Status Date <sup *ngIf="isStatusDateRequired">*</sup></label
                    >
                    <input
                      type="date"
                      class="form-control"
                      formControlName="statusDate"
                      [ngClass]="{
                        'is-invalid': f['statusDate'].errors && f['statusDate'].touched
                      }" />
                    <app-validation
                      field="statusDate"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'Status date is required',
                        futureDate: 'Future date is not allowed'
                      }"></app-validation>
                  </div>

                  <div class="pt-2">
                    <label for="acknowledgeSharedStatus" class="form-label"
                      >Acknowledge Shared Status <sup *ngIf="isAcknowledgeSharedStatusMandatory">*</sup></label
                    >
                    <select
                      class="form-select"
                      aria-label="Acknowledge Shared Status"
                      formControlName="acknowledgeSharedStatus"
                      [ngClass]="{
                        'is-invalid': f['acknowledgeSharedStatus'].errors && f['acknowledgeSharedStatus'].touched
                      }">
                      <option selected value="">Select Acknowledge Shared Status</option>
                      <option
                        *ngFor="let acknowledgeShareStatus of acknowledgeShareStatusOptionsList"
                        value="{{ acknowledgeShareStatus?.key2 }}">
                        {{ acknowledgeShareStatus?.key1 }}
                      </option>
                    </select>
                    <app-validation
                      field="acknowledgeSharedStatus"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                  <div class="pt-2">
                    <label for="requestCompletionStatus" class="form-label"
                      >Request Completion Status<sup>*</sup></label
                    >
                    <select
                      class="form-select"
                      aria-label="Request Completion Status"
                      formControlName="requestCompletionStatus"
                      [ngClass]="{
                        'is-invalid': f['requestCompletionStatus'].errors && f['requestCompletionStatus'].touched
                      }">
                      <option [disabled]="true" selected value="">Select Request Completion Status</option>
                      <option
                        *ngFor="let requestCompletionStatus of requestCompletionStatusOptionsList"
                        value="{{ requestCompletionStatus?.key2 }}">
                        {{ requestCompletionStatus?.key1 }}
                      </option>
                    </select>
                    <app-validation
                      field="requestCompletionStatus"
                      [form]="trackerDetailsForm"
                      [error]="{
                        required: 'This field is required'
                      }"></app-validation>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="statusHistory" class="form-label">Status History </label>
                  <div class="table-wrapper">
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Status</th>
                          <th scope="col">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let statusHistory of statusHistory">
                          <tr>
                            <td>
                              {{ statusHistory.status }}
                            </td>
                            <td>
                              {{ statusHistory.recordedAt | date : 'dd/MM/yyyy' }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-md-12 p-2">
                  <label for="remarks" class="form-label">Remarks</label>
                  <textarea
                    class="form-control"
                    formControlName="remarks"
                    style="height: 120px"
                    [ngClass]="{
                      'is-invalid': f['remarks'].errors && f['remarks'].touched
                    }"></textarea>
                  <app-validation
                    field="remarks"
                    [form]="trackerDetailsForm"
                    [error]="{
                          minLength: 'Remarks should have a minimum of 3 characters',
                          maxLength: 'Remarks should should not exceed 300 characters',
                        }"></app-validation>
                </div>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <a>
                <button type="button" class="btn" (click)="updateOfflineTracker()">SAVE & EXIT</button>
              </a>
              <a>
                <button type="button" class="btn-discard" (click)="exit()">EXIT</button>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
